import { ResumePetisSimulationProposalClientResponse } from '../../../@types/ResumePetisSimulationProposal'
import { useGetQuotationStore } from '../../../Stores/useGetQuotationStore'
import { useQuotationStore } from '../../../Stores/useQuotationStore'
import { useRequestQuotationStore } from '../../../Stores/useRequestQuotationStore'
import {
  mountedAttachmentsQuotation,
  mountedMessagesQuotation,
} from './utils/mountedGetQuotation'

export const useQuotationHydration = () => {
  const {} = useQuotationStore() // check if needs update
  const { setRequestQuotation } = useRequestQuotationStore() //Needs to set the quotationID
  const { setGetQuotation } = useGetQuotationStore() //Set messages and attachments

  const handleGetQuotationHydration = (
    resume: ResumePetisSimulationProposalClientResponse,
  ) => {
    setGetQuotation({
      policyQuotation: {
        messages: mountedMessagesQuotation(
          resume.processData?.quotationData?.messages || [],
        ),
        attachments: mountedAttachmentsQuotation(
          resume.processData?.quotationData?.documents || [],
        ),
        quotationId: resume.processData?.quotationData?.quotationId,
        status: resume.processData?.quotationData?.status,
      },
    })
  }

  const handleRequestQuotationHydration = (
    resume: ResumePetisSimulationProposalClientResponse,
  ) => {
    setRequestQuotation({
      quotationId: resume.processData?.quotationData?.quotationId,
      taskId: resume.processData?.task?.taskId,
    })
  }

  return {
    handleGetQuotationHydration,
    handleRequestQuotationHydration,
  }
}
